import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles({
  heading: {
    fontSize: 24,
    lineHeight: '28px',
    fontWeight: 'bold'
  },
  myAppointments: {
    fontSize: 20,
    lineHeight: '40px',
    fontWeight: 'normal'
  },
  subheading: {
    fontSize: 18,
    fontWeight: 'bold'
  },
  viewButton: {
    position: 'absolute',
    right: 25,
    bottom: 15
  },
  paragraph: {
    fontSize: 14
  }
})

export default useStyles;